import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import {
    EngageAdvChannelsResponse,
    EngageAdvDailyLeadsResponse,
    EngageAdvFilter,
    EngageAdvFilterOptionsResponse,
    EngageAdvLeadGenResponse,
    EngageAdvSummaryResponse
} from '../models/engage-advertising.model';
import { delayedRetryHttp } from './shared/delayedRetry';
import { UtilityService } from './shared/utility.service';

@Injectable({
    providedIn: 'root'
})
export class EngageAdvertisingService {
    private baseUrl: string;
    private api: string = 'api/EngageDashboard';

    constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string,
                private _utilityService: UtilityService) {
        this.baseUrl = _baseUrl + this.api;
    }

    private headers(encryptedUser: string): HttpHeaders {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Basic ' + encryptedUser
        });
    }

    async summary(encryptedUser: string, filter: EngageAdvFilter): Promise<EngageAdvSummaryResponse | void> {
        return await this.httpClient
            .post<EngageAdvSummaryResponse>(`${this.baseUrl}/AdvertisingSummary`, filter, { headers: this.headers(encryptedUser) })
            .pipe(delayedRetryHttp()).toPromise()
            .catch(err => {
                this._utilityService.handleErrors(err, filter, 'r - ' + encryptedUser, encryptedUser,
                    'EngageAdvertisingService', 'summary');
            });
    }

    async dailyLeads(encryptedUser: string, filter: EngageAdvFilter): Promise<EngageAdvDailyLeadsResponse | void> {
        return await this.httpClient
            .post<EngageAdvDailyLeadsResponse>(`${this.baseUrl}/AdvertisingDailyLeads`, filter, { headers: this.headers(encryptedUser) })
            .pipe(delayedRetryHttp()).toPromise()
            .catch(err => {
                this._utilityService.handleErrors(err, filter, 'r - ' + encryptedUser, encryptedUser,
                    'EngageAdvertisingService', 'dailyLeads');
            });
    }

    async channels(encryptedUser: string, filter: EngageAdvFilter): Promise<EngageAdvChannelsResponse | void> {
        return await this.httpClient
            .post<EngageAdvChannelsResponse>(`${this.baseUrl}/AdvertisingChannels`, filter, { headers: this.headers(encryptedUser) })
            .pipe(delayedRetryHttp()).toPromise()
            .catch(err => {
                this._utilityService.handleErrors(err, filter, 'r - ' + encryptedUser, encryptedUser,
                    'EngageAdvertisingService', 'channels');
            });
    }

    async leadGen(encryptedUser: string, filter: EngageAdvFilter): Promise<EngageAdvLeadGenResponse | void> {
        return await this.httpClient
            .post<EngageAdvLeadGenResponse>(`${this.baseUrl}/AdvertisingLeadGen`, filter, { headers: this.headers(encryptedUser) })
            .toPromise()
            .catch(err => {
                this._utilityService.handleErrors(err, filter, 'r - ' + encryptedUser, encryptedUser,
                    'EngageAdvertisingService', 'leadGen');
            });
    }

    async filterOptions(encryptedUser: string): Promise<EngageAdvFilterOptionsResponse | void> {
        return await this.httpClient
            .get<EngageAdvFilterOptionsResponse>(`${this.baseUrl}/AdvertisingFilterOptions`, { headers: this.headers(encryptedUser) })
            .pipe(delayedRetryHttp()).toPromise()
            .catch(err => {
                this._utilityService.handleErrors(err, null, 'r - ' + encryptedUser, encryptedUser,
                    'EngageAdvertisingService', 'filterOptions');
            });
    }
}
